"use strict";

import _classCallCheck from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { defineReadOnly } from "@ethersproject/properties";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
var logger = new Logger(version);
import { JsonRpcProvider } from "./json-rpc-provider";
var _nextId = 1;

function buildWeb3LegacyFetcher(provider, sendFunc) {
  return function (method, params) {
    // Metamask complains about eth_sign (and on some versions hangs)
    if (method == "eth_sign" && (provider.isMetaMask || provider.isStatus)) {
      // https://github.com/ethereum/go-ethereum/wiki/Management-APIs#personal_sign
      method = "personal_sign";
      params = [params[1], params[0]];
    }

    var request = {
      method: method,
      params: params,
      id: _nextId++,
      jsonrpc: "2.0"
    };
    return new Promise(function (resolve, reject) {
      sendFunc(request, function (error, result) {
        if (error) {
          return reject(error);
        }

        if (result.error) {
          var _error = new Error(result.error.message);

          _error.code = result.error.code;
          _error.data = result.error.data;
          return reject(_error);
        }

        resolve(result.result);
      });
    });
  };
}

function buildEip1193Fetcher(provider) {
  return function (method, params) {
    if (params == null) {
      params = [];
    } // Metamask complains about eth_sign (and on some versions hangs)


    if (method == "eth_sign" && (provider.isMetaMask || provider.isStatus)) {
      // https://github.com/ethereum/go-ethereum/wiki/Management-APIs#personal_sign
      method = "personal_sign";
      params = [params[1], params[0]];
    }

    return provider.request({
      method: method,
      params: params
    });
  };
}

export var Web3Provider = /*#__PURE__*/function (_JsonRpcProvider) {
  _inherits(Web3Provider, _JsonRpcProvider);

  var _super = _createSuper(Web3Provider);

  function Web3Provider(provider, network) {
    var _this;

    _classCallCheck(this, Web3Provider);

    logger.checkNew(this instanceof Web3Provider ? this.constructor : void 0, Web3Provider);

    if (provider == null) {
      logger.throwArgumentError("missing provider", "provider", provider);
    }

    var path = null;
    var jsonRpcFetchFunc = null;
    var subprovider = null;

    if (typeof provider === "function") {
      path = "unknown:";
      jsonRpcFetchFunc = provider;
    } else {
      path = provider.host || provider.path || "";

      if (!path && provider.isMetaMask) {
        path = "metamask";
      }

      subprovider = provider;

      if (provider.request) {
        if (path === "") {
          path = "eip-1193:";
        }

        jsonRpcFetchFunc = buildEip1193Fetcher(provider);
      } else if (provider.sendAsync) {
        jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
      } else if (provider.send) {
        jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
      } else {
        logger.throwArgumentError("unsupported provider", "provider", provider);
      }

      if (!path) {
        path = "unknown:";
      }
    }

    _this = _super.call(this, path, network);
    defineReadOnly(_assertThisInitialized(_this), "jsonRpcFetchFunc", jsonRpcFetchFunc);
    defineReadOnly(_assertThisInitialized(_this), "provider", subprovider);
    return _this;
  }

  _createClass(Web3Provider, [{
    key: "send",
    value: function send(method, params) {
      return this.jsonRpcFetchFunc(method, params);
    }
  }]);

  return Web3Provider;
}(JsonRpcProvider);